import React, { useState, useEffect } from 'react';
import { View } from 'react-native';
import Slider from '../../Slider';
import { PricingCard } from "react-native-elements";
import { AlertBox } from '../../AlertBox';
import useViewport from '../../../hooks/useViewport';
import { useNavigation, useIsFocused } from "@react-navigation/native";
import MultipleTexts from './MultipleTexts';
import { Provider } from "react-native-paper";
import { StandardText } from '../../../config/theme/globalStyles';

const PlansCardsWithoutFlatlist = ({ user, firstPlanPurchase, plansInfo, component, isAdmin, plan }) => {
  const { width } = useViewport();
  const breakpoint = 1080;

  const [visibleAlert, setVisibleAlert] = useState(false);
  const [title, setTitle] = useState(null);
  const [message, setMessege] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const navigation = useNavigation();
  const isFocused = useIsFocused();


  useEffect(() => {
    return navigation.addListener("beforeRemove", () => {
      setIsLoading(false);
    }), navigation.addListener("focus", () => {
      setIsLoading(false);
    });
  }, [navigation, isFocused]);

  const showAlert = (title, message) => {
    setVisibleAlert(true);
    setTitle(title);
    setMessege(message);
  };

  const hideAlert = (status) => {
    setVisibleAlert(status);
  };

  const onSubscriptionButtonPress = async (productId, billing_address_collection) => {
    if (user?.plan) {
      showAlert("Ops!", "Você já possui um plano de assinatura! Para adquirir um novo plano, você precisa cancelar o que já possui ou criar um novo login.");
      setIsLoading(false);
    } else if (plan) {
      showAlert("Ops!", "Você já possui um plano de assinatura! Para adquirir um novo plano, você precisa cancelar o que já possui ou criar um novo login.");
      setIsLoading(false)
    } else {
      const purchaseType = "PLAN";
      navigation.navigate("Cadastro", { purchaseType, productId, mode: "subscription", billing_address_collection });
    }
  };


  const PlanCard = ({ item, index }) => {

    const content = [
      {
        text: item.monthlyPrice ? item.monthlyPrice : item.quarterlyPrice ? item.quarterlyPrice : item.semiannualPrice ? item.semiannualPrice : item.yearlyPrice,
        style: (width) => ({ ...component.pricingStyle(width, index) })
      },
      {
        text: item.monthlyPrice ? `/ por mês` : item.quarterlyPrice ? `/ por mês, durante 3 meses` : item.semiannualPrice ? `/ por mês, durante 6 meses` : `/ por mês, durante 12 meses`,
        style: (width) => ({ ...component.pricingStyle(width, index), fontSize: width < breakpoint ? 14 : 14 })
      },
    ]

    return (
      <>
        {item.isBestPrice && (
          <View style={{
            position: 'absolute',
            top: 0,
            right: 0,
            backgroundColor: component?.bestOptionColor,
            borderRadius: "50%",
            padding: 5,
            zIndex: 2,
            width: 75,
            height: 75,
            justifyContent: "center",
            borderColor: "#FFFFFF",
            borderWidth: "2px"
          }}>
            <StandardText style={{ color: "#FFFFFF", fontSize: 12 }}>
              MELHOR OPÇÃO
            </StandardText>
          </View>
        )}
        <PricingCard
          key={item.id}
          title={item.title}
          color={component.titleStyle(width, index).color}
          price={
            <View style={{
              width: "100%",
              flexDirection: "row",
            }}>
              <View
                style={{
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  flexWrap: "wrap", // Permite que o texto ocupe duas linhas
                  width: "100%"
                }}
              >
                <MultipleTexts component={component} content={content} width={width}></MultipleTexts>
              </View>
            </View>
          }
          info={item.infosMonthly ? item.infosMonthly : item.infosQuarterly ? item.infosQuarterly : item.infosSemiannual ? item.infosSemiannual : item.infosYearly}
          titleStyle={
            {
              ...component.titleStyle(width, index), width: "100%"
            }
          }
          infoStyle={
            {
              ...component.infoStyle(width, index),
            }
          }
          pricingStyle={
            {
              ...component.pricingStyle(width, index)
            }
          }
          button={{
            title: item.priceIdHidden == true ? "EM BREVE" : "ASSINAR",
            loading: selectedCard === item.id && isLoading,
            color: component.buttonStyle(width, index).color,
            titleStyle: component.buttonStyle(width, index).titleStyle,
            buttonStyle: component.buttonStyle(width, index).style,
            containerStyle: { marginTop: "auto" },
          }}
          containerStyle={{
            ...component.cardStyle(width, index),
            borderRadius: 15,
            borderWidth: "2px",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: width < breakpoint ? width * 0.8 : width * 0.30,
          }}
          wrapperStyle={{
            width: "100%",
            height: "100%",
            paddingHorizontal: width < breakpoint ? "0rem" : "1rem",
            paddingVertical: "2rem",
          }}
          onButtonPress={() => {
            if (isAdmin || item.priceIdHidden == true) {
              return;
            }
            setSelectedCard(item.id);
            setIsLoading(true);
            (async () => {
              try {
                await onSubscriptionButtonPress(
                  item.productIds.monthly ? item.productIds.monthly : item.productIds.quarterly ? item.productIds.quarterly : item.productIds.semiannual ? item.productIds.semiannual : item.productIds.yearly,
                  item?.billing_address_collection
                );
                setIsLoading(false);
              } catch (error) {
                // Trate o erro, se necessário.
                console.error(error);
                setIsLoading(false);
              }
            })();
          }}
        />
      </>
    )
  }

  const planCards = plansInfo.map((item, index) => (
    <PlanCard item={item} index={index} />
  ));

  return (
    <Provider>
      {width < breakpoint ? (
        <>
          {plansInfo.map((item, index) => (
            <View style={{ flexBasis: "auto", justifyContent: 'center', alignItems: 'center', flexDirection: 'column', marginBottom: '1rem' }}>
              <PlanCard item={item} index={index} />
              {visibleAlert && (
                <AlertBox
                  title={title}
                  message={message}
                  visible={visibleAlert}
                  onClose={hideAlert}
                ></AlertBox>
              )}
            </View>
          ))}
        </>
      ) : width > breakpoint && width - 64 > component.cardStyle(width).width * plansInfo.length ? (
        <View style={{ flex: 1, justifyContent: 'center', flexDirection: 'row', marginBottom: "2rem" }}>
          {plansInfo.map((item, index) => (
            <PlanCard item={item} index={index} />
          ))}
          {visibleAlert && (
            <AlertBox
              title={title}
              message={message}
              visible={visibleAlert}
              onClose={hideAlert}
            ></AlertBox>
          )}
        </View>
      ) : (
        <>
          <Slider array={planCards} cardWidth={component.cardStyle(width).width} component={component} width={width}></Slider>
          {visibleAlert && (
            <AlertBox
              title={title}
              message={message}
              visible={visibleAlert}
              onClose={hideAlert}
            ></AlertBox>
          )}
        </>
      )
      }
    </Provider>
  )
}

export default PlansCardsWithoutFlatlist